import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "project-page" }
const _hoisted_2 = { class: "project_details-section section-padding" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row mt-5 mb-5" }
const _hoisted_5 = { class: "col-xl-12" }
const _hoisted_6 = { class: "images" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]

import { ref, onMounted, onUnmounted } from 'vue';
import ApiService from '@/services/ApiService';
import { useRoute } from 'vue-router';
import { getUrlApiForFiles } from '@/utils/utils';

interface Article {
  id: number;
  titre: string;
  sousTitre: string;
  urlImage?: string;
  contenu: string;
  datePublication: Date;
  nbrupload: number;
  categorieArticle?: {
    id: number;
    nom: string;
  };

}

interface Media {
  id: number;
  type: string;
  description: string;
  articleId: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsPhoto',
  setup(__props) {

const route = useRoute();
const article = ref<Article | null>(null);
const medias = ref<Media[]>([]);
const currentMediaIndex = ref(0);
const showModal = ref(false);
const currentImage = ref('');

// const API_IMAGE_BASE_URL = 'http://localhost:3001/uploads/';

function getImageUrl(filename?: string): string {
  if (!filename) return '';
  return `${ApiService.vueInstance.axios.defaults["updateUrl"]}uploads/${filename}`;
}

// Détection des types de médias
function isImage(filename: string): boolean {
  return /\.(jpg|jpeg|png|gif|webp)$/i.test(filename);
}
function isVideo(filename: string): boolean {
  return /\.(mp4|webm|ogg)$/i.test(filename);
}
function isPdf(filename: string): boolean {
  return /\.pdf$/i.test(filename);
}

//  Gestion modale (images uniquement)
function open(url: string) {
  currentImage.value = url;
  showModal.value = true;
}
function openImage(url: string, index: number) {
  currentImage.value = url;
  currentMediaIndex.value = index;
  showModal.value = true;
}
function nextImage() {
  if (!medias.value.length) return;
  currentMediaIndex.value =
    (currentMediaIndex.value + 1) % medias.value.length;
  currentImage.value = getImageUrl(medias.value[currentMediaIndex.value].type);
}
function prevImage() {
  if (!medias.value.length) return;
  currentMediaIndex.value =
    (currentMediaIndex.value - 1 + medias.value.length) % medias.value.length;
  currentImage.value = getImageUrl(medias.value[currentMediaIndex.value].type);
}
function closeModal() {
  showModal.value = false;
}

async function fetchArticleById(articleId: string | number) {
  const response = await ApiService.get(`/articles/${articleId}`);
  article.value = response.data.data;
}
async function fetchMedias(articleId: number) {
  const response = await ApiService.get(`/articles/medias/${articleId}`);
  medias.value = response.data.data || [];
  console.log("ggg",medias.value)
}

onMounted(async () => {
  await fetchArticleById(route.params.id as string);
  if (article.value) await fetchMedias(article.value.id);
});

return (_ctx: any,_cache: any) => {
  const _directive_viewer = _resolveDirective("viewer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
              (article.value && article.value.urlImage && isImage(article.value.urlImage))
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: _unref(getUrlApiForFiles)(article.value.urlImage),
                    class: "medias",
                    alt: "Image principale"
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(medias.value, (media) => {
                return (_openBlock(), _createElementBlock("img", {
                  key: media.id,
                  src: _unref(getUrlApiForFiles)(media.type),
                  class: "medias",
                  alt: "Image de l'article"
                }, null, 8, _hoisted_8))
              }), 128))
            ])), [
              [_directive_viewer, {
              toolbar: true,
              title: true,
              navbar: true,
              fullscreen: true,
              movable: true,
              transition: true,
              button: true,
              play: true
              }]
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})